import React from "react";
import { IconButton, FocusTrapZone, Layer, Overlay, Popup, DefaultButton, mergeStyleSets } from "@fluentui/react";
import { Trans } from "react-i18next";
import i18next from "../../../i18n/i18n";
import styles from "../Chat.module.css";

const popupStyles = mergeStyleSets({
    root: {
        background: "rgba(0, 0, 0, 0.5)",
        bottom: "0",
        left: "0",
        position: "absolute",
        right: "0",
        top: "0"
    },
    content: {
        background: "white",
        left: "50%",
        maxWidth: "1000px",
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "10px",
        border: "2px solid",
        borderColor: "grey",
        padding: "15px"
    }
});

interface WarningPopupProps {
    type: "private" | "emptyProduct";
    isVisible: boolean;
    onDismiss: () => void;
}

export const WarningPopup: React.FC<WarningPopupProps> = ({ type, isVisible, onDismiss }) => {
    if (!isVisible) return null;

    return (
        <Layer>
            <Popup className={popupStyles.root} role="dialog" aria-modal="true" onDismiss={onDismiss}>
                <Overlay />
                <FocusTrapZone>
                    <div role="document" className={popupStyles.content}>
                        <div>
                            <IconButton
                                className={styles.warningIconRed}
                                iconProps={{ iconName: "WarningSolid" }}
                                ariaLabel={i18next.t("chat.warning")}
                                title={i18next.t("chat.warning")}
                            />
                            <IconButton
                                className={styles.warningIconGreen}
                                iconProps={{ iconName: "Cancel" }}
                                onClick={onDismiss}
                                ariaLabel={i18next.t("chat.close")}
                                title={i18next.t("chat.close")}
                            />
                            {type === "private" ? (
                                <>
                                    <span className={styles.devSettingsLabel}>
                                        <Trans i18nKey="chat.warning1" />
                                    </span>
                                    <span className={styles.devSettingsValue}>
                                        <Trans i18nKey="chat.warning2" />
                                    </span>
                                    <span className={styles.devSettingsValue}>
                                        <Trans i18nKey="chat.warning3" />
                                    </span>
                                    <span className={styles.devSettingsValue}>
                                        <Trans i18nKey="chat.warning4" />
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span className={styles.devSettingsLabel}>
                                        <Trans i18nKey="chat.warning6" />
                                    </span>
                                    <span className={styles.devSettingsValue}>
                                        <Trans i18nKey="chat.warning7" />
                                    </span>
                                </>
                            )}
                        </div>
                        <DefaultButton autoFocus className={styles.warningPanel} onClick={onDismiss}>
                            {i18next.t("chat.ok")}
                        </DefaultButton>
                    </div>
                </FocusTrapZone>
            </Popup>
        </Layer>
    );
};
